import { Table } from 'appkit-react';

const ExceptionResult = ({ fileName, exceptionData, columns }) => (
    <>
        {!fileName && exceptionData.length > 0 ? (
            <>
                <Table
                    data={exceptionData}
                    columns={columns}
                    defaultPageSize={10}
                    sortable
                    size="lg"
                    resizable
                    className="-striped -highlight ReactTable rt-expander"
                    style={{ marginTop: '1rem' }}
                />
            </>
        ) : (
            <div
                className="a-h6"
                style={{
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    padding: '0.5rem 0.5rem',
                    borderRadius: '3px',
                    width: '100%',
                    textAlign: 'center',
                    borderColor: '#f5c6cb',
                    marginTop: '1rem',
                }}
            >
                No exception data found for this operation.
            </div>
        )}
    </>
);

export default ExceptionResult;
